// Primeira linha do cabecalho: nome + nota a esquerda, compartilhar a direita.
// Abaixo vem o slogan da loja (quando cadastrado) e o endereco curto (rua e
// numero) com link pro Maps.
//
// As redes sociais sairam daqui em 25/08/2026 (decisao do dono) — seguem no
// modal "Informacoes da Loja".

import { MapPin, Share2, Star } from "lucide-react";

export default function StoreIdentity({
  nome, slogan, stats, enderecoCurto, mapsUrl, t, onShare, onOpenReviews,
}) {
  return (
    <div>
      <div className="flex items-center gap-3">
        <h1 className={`text-base lg:text-2xl font-bold tracking-tight truncate ${t.text}`}>{nome}</h1>
        <Nota stats={stats} t={t} onClick={onOpenReviews} />

        <button
          type="button"
          onClick={onShare}
          title="Compartilhar cardápio"
          aria-label="Compartilhar cardápio"
          className={`ml-auto flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center ${t.textMuted} hover:bg-black/5 dark:hover:bg-white/10 transition-colors`}
        >
          <Share2 className="w-4 h-4" strokeWidth={2} />
        </button>
      </div>

      {/* Slogan como assinatura da marca: entra logo abaixo do nome, em
          itálico e discreto — identifica a loja sem competir com o nome nem
          empurrar o endereço pra fora do cartão. */}
      {slogan && (
        <p className={`mt-0.5 text-[11px] lg:text-sm italic ${t.textMuted} line-clamp-1 lg:line-clamp-2`}>
          {slogan}
        </p>
      )}

      {enderecoCurto && (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          title="Abrir no Google Maps"
          className={`inline-flex items-center gap-1.5 mt-0.5 lg:mt-1 text-[11px] lg:text-sm ${t.textMuted} hover:underline max-w-full`}
        >
          <MapPin className="w-4 h-4 flex-shrink-0" strokeWidth={2} />
          <span className="truncate">{enderecoCurto}</span>
        </a>
      )}
    </div>
  );
}

/** Nota media ao lado do nome, clicavel pra abrir as avaliacoes. Loja sem
 *  avaliacao ainda nao mostra nada — "0,0" ao lado do nome pesa contra a loja
 *  sem informar. */
function Nota({ stats, t, onClick }) {
  const avg = stats?.review_avg;
  const count = stats?.review_count || 0;
  if (avg == null || count === 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      title="Ver avaliações"
      className="inline-flex items-center gap-1.5 flex-shrink-0 hover:opacity-80 transition-opacity"
    >
      <Star className="w-4 h-4 text-amber-500 fill-amber-500" />
      <span className={`text-[13px] lg:text-sm font-bold tabular-nums ${t.text}`}>
        {Number(avg).toFixed(1).replace(".", ",")}
      </span>
      {/* No celular a linha do nome nao comporta "(100 avaliações)" por
          extenso sem espremer o nome da loja — so o numero. */}
      <span className={`text-[13px] lg:text-sm ${t.textMuted}`}>
        ({count}<span className="hidden lg:inline"> {count === 1 ? "avaliação" : "avaliações"}</span>)
      </span>
    </button>
  );
}
